import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';
import { environment } from '../../../../../../../environments/environment';
import { ImageUtils } from '../../../../../../common/utils/image-utils';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-table-cell-image',
  templateUrl: './image-table-cell.component.html',
  styles: ['.small-image { height: 36px;width: 36px;}'],
  standalone: false,
})
export class ImageTableCellComponent extends DataTypeComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  imageSrc: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.imageSrc = this.figureOutSrc();
  }

  private figureOutSrc(): string {
    const value = this.formGroup?.get(this.fieldConfig?.name)?.value ?? this.data;
    if (value) {
      if (typeof value === 'string' && value.indexOf('./assets/') >= 0) {
        return ImageUtils.relocateImage(value);
      }
      if (typeof value === 'string' && value.startsWith('http')) {
        return value;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.imageSrc = this.figureOutSrc();
  }
}
